export const showNavBar = (routeName) => {
	const excludedRoutes = [
		null,
		'Onboarding',
		'TestPositionnement',
		'Login',
		'Register',
		'LoginSSO',
		'LoginSSOProcess',
		'MicrosoftCallback',
		'ForgetPassword',
		'OnboardingFormationTopic',
	];
	return !excludedRoutes.includes(routeName);
};

export const showRedactionNavItems = (routeName) => {
	const redactionPathNames = [
		'Topic Dashboard',
		'Topic Dashboard Index',
		'Topic Dashboard Parcours Detail',
		'Topic Dashboard Chapter Detail',
		'SessionDetailPage',
		'TrackPage',
		'SessionResultPage',
		'Report Session Parcours Index',
		'Chapter Report',
		'Parcours Report',
		'End Formation Report',
	];
	return redactionPathNames.includes(routeName);
};
